import React, {useEffect, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
// import {useDispatch} from 'react-redux';
// import {Gatekeeper} from 'gatekeeper-client-sdk';
// import {loadUser, logoutUser} from '@store/reducers/auth';
import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import Account from '@pages/account/Account';
import AccountAdd from '@pages/account/AccountAdd';
import AccountEdit from '@pages/account/AccountEdit';

import EmailConfig from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit from '@pages/emailConfig/EmailConfigEdit';

import Log from '@pages/log/Log';

import LoginHistory from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory from '@app/pages/report/countLogin/StatisticLoginHistory';

// import ReportPostByWebAnalysis from '@pages/report/ReportPostByWebAnalysis';
// import ReportPostQuantityCreateBy from '@app/pages/report/ReportPostQuantityCreateBy';
// import ReportPostCreateBy from '@app/pages/report/ReportPostCreateBy';
// import ReportViewDetail from '@app/pages/report/reportViewDetail/ReportViewDetail';
// import ReportPostPublishTimeAndDataType from '@pages/report/ReportPostPublishTimeAndDataType';
// import RepostAdvertising from '@pages/report/RepostAdvertising';

import Header from './header/Header';
import Footer from './footer/Footer';
import MenuSidebar from './menu-sidebar/MenuSidebar';

import {URI_INTERNAL} from '../../utils/pathLocations';
import Welcome from '@app/pages/Welcome/Welcome';
import DynamicGoiThau from '@app/pages/DynamicGoiThau/DynamicGoiThau';
import DynamicStep from '@app/pages/DynamicGoiThau/DynamicStep';
import Project from '@app/pages/Project/Project';
import HoSoDetail from '@app/pages/HoSo/HoSoDetail';
import NhanVienInput from '@app/pages/HoSo/NhanVienInput';
import BaiBaoList from '@app/pages/BaiBao/BaiBaoList';
import DeTaiList from '@app/pages/DeTai/DeTaiList';
import SangCheList from '@app/pages/SangChe/SangCheList';
import GiaiThuongList from '@app/pages/GiaiThuong/GiaiThuongList';
import SachList from '@app/pages/Sach/SachList';
import HuongDanHocVienList from '@app/pages/HuongDanHocVien/HuongDanHocVienList';
import GiaiThuongDaoTaoList from '@app/pages/GiaiThuongDaoTao/GiaiThuongDaoTaoList';
import DonViList from '@app/pages/DanhMuc/DonViList';
import HocViList from '@app/pages/DanhMuc/HocViList';
import ChucDanhKhoaHocList from '@app/pages/DanhMuc/ChucDanhKhoaHocList';
import ChucVuList from '@app/pages/DanhMuc/ChucVuList';

// import PageLoading from '../../components/page-loading/PageLoading';

const Main = () => {
    // const [appLoadingState, updateAppLoading] = useState(false);
    // const dispatch = useDispatch();

    // useEffect(() => {
    //     updateAppLoading(true);
    //     const fetchProfile = async () => {
    //         try {
    //             const response = await Gatekeeper.getProfile();
    //             dispatch(loadUser(response));
    //             updateAppLoading(false);
    //         } catch (error) {
    //             dispatch(logoutUser());
    //             updateAppLoading(false);
    //         }
    //     };
    //     fetchProfile();
    //     return () => {};
    // }, []);

    // useEffect(() => {

    // }, []);

    // const token = localStorage.getItem(TOKEN_KEY);

    // // const [permitted, setPermitted] = useState()

    // if (token) {
    // }

    useEffect(() => {
        const rootEl = document.getElementById('root');
        if (rootEl) {
            rootEl.classList.remove('register-page');
            rootEl.classList.remove('login-page');
            rootEl.classList.remove('hold-transition');
        }
        document.body.classList.add('sidebar-mini');

        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 992) {
                document.body.classList.add('sidebar-collapse');
                document.body.classList.remove('sidebar-open');
            } else {
                document.body.classList.remove('sidebar-open');
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleMenuSidebar = () => {
        document.body.classList.add('sidebar-collapse');
        document.body.classList.remove('sidebar-open');
    };

    const template = (
        <>
            <Header />

            <MenuSidebar />

            <div className="content-wrapper">
                <div className="pt-3" />
                <section className="content">
                    <Switch>
                        <Route exact path="/profile" component={Profile} />
                        <Route exact path={URI_INTERNAL.PROFILE_CV} component={HoSoDetail} />
                        <Route exact path={`${URI_INTERNAL.PROFILE_CV}/:id`} component={HoSoDetail} />
                        <Route exact path={URI_INTERNAL.NHAN_VIEN_INPUT} component={NhanVienInput} />
                        <Route exact path={`${URI_INTERNAL.NHAN_VIEN_INPUT}/:id`} component={NhanVienInput} />
                        <Route exact path="/" component={Welcome} />
                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNT_PATH}
                            component={Account}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNT_PATH_ADD}
                            component={AccountAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNT_PATH_EDIT}
                            component={AccountEdit}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.EMAILCONFIG_PATH}
                            component={EmailConfig}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.EMAILCONFIG_CREATE_PATH}
                            component={EmailConfigAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.EMAILCONFIG_EDIT_PATH}
                            component={EmailConfigEdit}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.LOGIN_HISTORY_PATH}
                            component={LoginHistory}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.STATISTIC_HISTORY_PATH}
                            component={StatisticLoginHistory}
                        />
                        
                        <Route
                            exact
                            path={URI_INTERNAL.DynamicGoiThau}
                            component={DynamicGoiThau}
                        />
                        
                        <Route
                            exact
                            path={URI_INTERNAL.DynamicStep}
                            component={DynamicStep}
                        />
                        
                        <Route
                            exact
                            path={URI_INTERNAL.PROJECT_PATH}
                            component={Project}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.WELCOME_PATH}
                            component={Welcome}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.BAI_BAO_PATH}
                            component={BaiBaoList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DE_TAI_PATH}
                            component={DeTaiList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.SANG_CHE_PATH}
                            component={SangCheList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.GIAI_THUONG_PATH}
                            component={GiaiThuongList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.SACH_PATH}
                            component={SachList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.HUONG_DAN_HOC_VIEN_PATH}
                            component={HuongDanHocVienList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.GIAI_THUONG_DAO_TAO_PATH}
                            component={GiaiThuongDaoTaoList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DANH_MUC_DON_VI}
                            component={DonViList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DANH_MUC_HOC_VI}
                            component={HocViList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DANH_MUC_CHUC_DANH}
                            component={ChucDanhKhoaHocList}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DANH_MUC_CHUC_VU}
                            component={ChucVuList}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.LOG_PATH}
                            component={Log}
                        />
                    </Switch>
                </section>
            </div>
            <Footer />
            <div
                id="sidebar-overlay"
                role="presentation"
                onClick={toggleMenuSidebar}
                onKeyDown={() => {}}
            />
        </>
    );

    // if (appLoadingState) {
    //     template = <PageLoading />;
    // } else {
    //     template = (
    //         <>
    //             <Header toggleMenuSidebar={toggleMenuSidebar} />

    //             <MenuSidebar />

    //             <div className="content-wrapper">
    //                 <div className="pt-3" />
    //                 <section className="content">
    //                     <Switch>
    //                         <Route exact path="/profile" component={Profile} />
    //                         <Route exact path="/" component={Dashboard} />
    //                     </Switch>
    //                 </section>
    //             </div>
    //             <Footer />
    //             <div
    //                 id="sidebar-overlay"
    //                 role="presentation"
    //                 onClick={toggleMenuSidebar}
    //                 onKeyDown={() => {}}
    //             />
    //         </>
    //     );
    // }

    return <div className="wrapper">{template}</div>;
};

export default Main;
